import { EXTENSIONS } from 'shared/constants/EXTENSIONS';
import { isImageExtension } from 'shared/utils/fileExtensions';

const MAIN_IMAGE_EXTENSIONS = new Set<string>([
  EXTENSIONS.WEBP,
  EXTENSIONS.JPG,
  EXTENSIONS.JPEG,
  EXTENSIONS.PNG,
]);

export function isSupportedAsMainImage(extension: string): boolean {
  const ext = extension.toLowerCase();
  return isImageExtension(ext) && MAIN_IMAGE_EXTENSIONS.has(ext);
}
